import NumberFormat from 'react-number-format'

interface MascaraProps {
  inputRef: (instance: NumberFormat | null) => void
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

export const MascaraInteiro = (props: MascaraProps) => {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        })
      }}
      decimalScale={0}
      thousandSeparator="."
      decimalSeparator=","
      allowNegative={false}
      isNumericString
    />
  )
}
